<template>
    <div class="logo">
        <div class="banner" v-cloak>
            <img class="banner_img" src="../../static/img/logo_banner.png" alt="">
        </div>
        <div class="conent">
            <!-- 集团概况 -->
            <div class="gk_wrap">
                <div class="gk w1200">
                    <p>集团概况</p>
                    <span></span>
                </div>
            </div>
            <div class="js_pic">
                <div class="pic_1">
                    <div class="js_img" v-for="(item,a) in $t('navbar.jtgk')" :key="a" @click="$router.push({path: item.path})">
                        <img :src="item.gsimg" alt="">
                        <span class="img_name">{{item.biaoti}}</span>
                        <div class="bj_img">
                            <img src="../../static/img/zhezhao.png" alt="">
                            <div class="text">
                                <h4>{{item.biaoti}}</h4>
                                <div class="wz">
                                    <p>{{item.wenzi}}</p>
                                </div>
                                <p class="gd">
                                    <span>{{item.gd}}</span>
                                    <span><img src="../../static/img/jtred.png" alt=""></span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 产业链及子公司 -->
            <div class="gk_wrap">
                <div class="gk w1200">
                    <p>产业链及子公司</p>
                    <span></span>
                </div>
            </div>
            <div class="cy w1200">
                <div class="cy_text">
                    <p class="sj_text">以科技创新为核心,引领新时代的互联网保险发展。</p>
                    <p class="sj_text">用科技的手段帮助各个保险公司在财险、团险、个险领域进行、成本调优、服务提升、客户体验感不断增强。</p>
                    <p class="sj_text">用科技能力驱动保险中介业务的发展,在客户基本保障的基础上，帮其在健康、弹性福利等领域持续享受高质量的增值服务。</p>
                </div>
                <div class="cy_js">
                    <div class="cy_js1">
                        <div class="yyy" @click="skip('http://www.feizhubaoxian.com')">
                            <img src="../../static/img/home_xhwb.png" alt="">
                            <p class="jz">协和万邦</p>
                            <p class="yy_text">
                                <span>协和万邦</span>
                            </p>
                        </div>
                        <div class="yyy" @click="skip('http://www.fescorock.com/')">
                            <img src="../../static/img/home_fsps.png" alt="">
                            <p class="jz">方胜磐石</p>
                            <p class="yy_text">
                                <span>方胜磐石</span>
                            </p>
                        </div>
                    </div>
                    <div class="cy_js2">
                        <h4>产品介绍</h4>
                        <p>专业的移动车险服务</p>
                        <p>·方便 ·快捷 ·安全</p>
                        <div class="cpimg">
                            <swiper></swiper>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="conent_1">
            <!-- 企业文化 -->
            <div class="qywh_wrap">
                <div class="qywh w1200">
                    <p>企业文化</p>
                    <span></span>
                </div>
            </div>
            <div class="news w1200">
                <p class="news_title">最新新闻
                </p>
                <ul class="news_text">
                    <li v-for="(item,i) in newz " :key="i">
                        <div class="left">
                            <span>{{item.day}}</span>
                            <span class="hx"></span>
                            <span>{{item.month}}</span>
                            <span>{{item.year}}</span>
                        </div>
                        <div class="right">
                            <h4>{{item.xwnr}}</h4>
                        </div>
                        <div class="ckgd" @click="$router.push({path:item.path})">
                            <p>
                                <span>查看更多</span>
                                <span><img src="../../static/img/baijt.png" alt=""></span>
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 合作伙伴 -->
            <div class="qywh_wrap">
                <div class="qywh w1200">
                    <p>合作伙伴</p>
                    <span></span>
                </div>
            </div>
            <div class="hzhb_wrap">
                <img class="img_hz" src="../../static/img/hezuoditu.png" alt="">
                <div class="hzhb w1200">
                    <img @click="skip('http://www.epicc.com.cn/')" src="../../static/img/home_hz_rb.png" alt="">
                    <img @click="skip('http://www.pingan.com')" src="../../static/img/home_hz_pa.png" alt="">
                    <img @click="skip('http://www.cic.cn/')" src="../../static/img/home_hz_zh.png" alt="">
                    <img @click="skip('http://www.cntaiping.com/')" src="../../static/img/home_hz_tp.png" alt="">
                    <img @click="skip('http://www.axatp.com/')" src="../../static/img/home_hz_as.png" alt="">
                    <img @click="skip('http://www.libertymutual.com.cn/')" src="../../static/img/home_hz_lb.png" alt="">
                    <img @click="skip('http://www.edhic.com/')" src="../../static/img/home_hz_dh.png" alt="">
                    <img @click="skip('http://www.zking.com/')" src="../../static/img/home_hz_zj.png" alt="">
                    <img @click="skip('http://www.95590.cn')" src="../../static/img/home_hz_dd.png" alt="">
                    <img @click="skip('https://www.sinosafe.com.cn/')" src="../../static/img/home_hz_ha.png" alt="">
                    <img @click="skip('https://www.zhongan.com')" src="../../static/img/home_hz_za.png" alt="">
                    <img @click="skip('http://www.95505.com.cn/')" src="../../static/img/home_hz_ta.png" alt="">
                    <img @click="skip('http://www.ihxlife.com')" src="../../static/img/home_hz_hx.png" alt="">
                    <img @click="skip('http://www.aeonlife.com.cn/')" src="../../static/img/home_hz_bn.png" alt="">
                </div>
            </div>
        </div>
        <div class="footer_Wrap">
            <div class=" footer_1 w1200">
                <div class="xx">
                    <div class="qx">
                        <p class="name">北京(总部)</p>
                        <p class="dizhi">北京市朝阳区朝阳门南大街16号楼</p>
                        <p class="dh">400-665-0265</p>
                    </div>
                    <div class="qx">
                        <p class="name">上海(分部)</p>
                        <p class="dizhi">上海市浦东新区宁桥路909号</p>
                        <p class="dh">400-665-0265</p>
                    </div>
                    <div class="qx">
                        <p class="name">山东(分部)</p>
                        <p class="dizhi">山东省潍坊市坊子区凤凰街168号</p>
                        <p class="dh">400-665-0265</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import swiper from '../components/Swiper.vue'
export default {
  name: 'logo',
  components: {
    swiper
  },
  data () {
    return {
      active: null,
      active2: null,
      newz: [
        {
          day: '18',
          month: '12',
          year: '2018',
          xwnr: '热烈庆祝北京飞猪科技获得了“中关村高新技术企业”证书',
          path: '/fzxw?page=4&id=0'
        },
        {
          day: '08',
          month: '11',
          year: '2018',
          xwnr: '北京飞猪科技董事长出席金融峰会并在当地调研',
          path: '/fzxw?page=4&id=1'
        },
        {
          day: '14',
          month: '08',
          year: '2018',
          xwnr: '北京飞猪科技在上海分公司召开第二季度会议',
          path: '/fzxw?page=4&id=2'
        },
        {
          day: '16',
          month: '07',
          year: '2018',
          xwnr: '发展与改革势在必行！',
          path: '/fzxw?page=4&id=3'
        },
        {
          day: '28',
          month: '06',
          year: '2018',
          xwnr: '北京飞猪科技车险保费跨越率在不断增涨，正在奋进行业前列',
          path: '/fzxw?page=4&id=4'
        },
        {
          day: '11',
          month: '06',
          year: '2018',
          xwnr: '离不开交流的技术与运营',
          path: '/fzxw?page=4&id=5'
        },
        {
          day: '20',
          month: '05',
          year: '2018',
          xwnr: '北京飞猪科技技术部门召开关于太平专属APP的会议',
          path: '/fzxw?page=4&id=6'
        }
      ]
    }
  },
  mounted () {
    //    let vm = this;
    // console.log(this.$t('navbar.jtgk'))
     if (this.isMobile()) {
          this.$router.push({ path: "/homes" });
        } else {
          this.$router.push({ path: "/logo" });
        }
  },
  methods: {
    skip (url) {
      location.href = url
    },
       isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
    .conent {
        width: 100%;
        background-color: #de101d;
        overflow: hidden;
        max-width: 19.2rem;
        margin: 0 auto;
        .gk_wrap {
            height: 1.05rem;
            background-color: #d0000e;
            margin: .5rem 0;
        }
        .gk {
            height: 1.05rem;
            line-height: 1.05rem;
            text-align: center;
            background-color: #d0000e;
            p {
                height: .8rem;
                line-height: .8rem;
                font-size: .3rem;
                color: #fcfffd;
            }
            span {
                width: .9rem;
                display: block;
                height: 3px;
                margin: 0 auto;
                border-bottom: 2px solid #fff;
            }
        }
        .js_pic {
            width: 100%;
            margin: 0 auto;
            .pic_1 {
                width: 100%;
                max-width: 19.2rem;
                overflow: hidden;
                margin: 0 auto;
                margin-bottom: .2rem;
                .js_img {
                    cursor: pointer;
                    width: 49.4%;
                    max-width: 9.5rem;
                    height: auto;
                    float: left;
                    position: relative;
                    overflow: hidden;
                    padding-bottom: .2rem;
                    img {
                        width: 100%;
                    }
                    .img_name {
                        position: absolute;
                        bottom: .37rem;
                        color: #fff;
                        width: 100%;
                        font-size: .26rem;
                        text-align: center;
                    }
                    .bj_img {
                        width: 100%;
                        height: 100%;
                        color: red;
                        position: absolute;
                        left: -100%;
                        transition: all 0.5s;
                        top: -0px;
                        z-index: 1;
                        .text {
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            top: 0;
                            left: 0;
                            font-size: .24rem;
                            padding: .7rem;
                            box-sizing: border-box;
                            h4 {
                                text-align: center;
                                line-height: .7rem;
                                font-size: .26rem;
                            }
                            p {
                                width: 100%;
                            }
                            .wz {
                                width: 100%;
                                p {
                                    height: 1.5rem;
                                    line-height: .5rem;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 3;
                                    overflow: hidden;
                                }
                            }
                            .gd {
                                display: flex;
                                justify-content: space-between;
                                line-height: .32rem;
                                box-sizing: border-box;
                                position: absolute;
                                padding: 0 .7rem;
                                bottom: .8rem;
                                left: 0;
                            }
                        }
                    }
                }
                .js_img:hover > .bj_img {
                    left: 0;
                }
                .js_img:hover > .img_name {
                    display: none;
                }
                .js_img:nth-child(even) {
                    float: right;
                    .bj_img {
                        right: -100%;
                        transition: all 0.5s;
                    }
                }
                .js_img:nth-child(2):hover > {
                    .bj_img {
                        right: 0;
                        transition: all 0.5s;
                    }
                    .img_name {
                        display: none;
                    }
                }
            }
        }
        .cy {
            .cy_text {
                p {
                    line-height: .3rem;
                    font-size: .28rem;
                    color: #fffdf4;
                    margin: .35rem 0;
                }
            }
        }
        .cy_js {
            .cy_js1 {
                display: flex;
                justify-content: space-between;
                margin-bottom: .5rem;
                .yyy {
                    height: 3.3rem;
                    position: relative;
                    cursor: pointer;
                    .jz {
                        width: 1.2rem;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 50%;
                        color: #fff;
                        margin: 0 auto;
                        line-height: 3.3rem;
                        font-size: .3rem;
                        display: none;
                    }
                    .yy_text {
                        width: 100%;
                        display: block;
                        height: .85rem;
                        line-height: .85rem;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        font-size: .3rem;
                        color: #fff;
                        background: url(../../static/img/home_ban_zz.png)
                            no-repeat center;
                        span {
                            padding-left: .32rem;
                        }
                    }
                    img {
                        display: block;
                        width: 5.9rem;
                        height: 3.3rem;
                    }
                }
                .yyy:hover {
                    opacity: 0.8;
                }
                .yyy:hover .jz {
                    display: block;
                }
                .yyy:hover .yy_text {
                    display: none;
                }
            }
            .cy_js2 {
                width: 12.5rem;
                margin: 0 auto;
                text-align: center;
                color: #fff;
                h4 {
                    font-size: .3rem;
                    line-height: .6rem;
                }
                p {
                    line-height: .28rem;
                    font-size: .2rem;
                }
                .cpimg {
                    margin-left: -.25rem;
                    width: 12.5rem;
                    padding: .4rem 0;
                    display: flex;
                    justify-content: space-around;
                }
            }
        }
    }
    .conent_1 {
        width: 100%;
        background-color: #0454ab;
        overflow: hidden;
        max-width: 19.2rem;
        margin: 0 auto;
        .qywh_wrap {
            width: 100%;
            background-color: #014693;
            margin-top: .5rem;
        }
        .qywh {
            height: 1.05rem;
            line-height: 1.05rem;
            text-align: center;
            background-color: #014693;
            p {
                height: .8rem;
                line-height: .8rem;
                font-size: .3rem;
                color: #fff;
            }
            span {
                width: .9rem;
                display: block;
                height: 3px;
                margin: 0 auto;
                border-bottom: 2px solid #fff;
            }
        }
        .news {
            height: 10.5rem;
            .news_title {
                width: 3.45rem;
                height: .88rem;
                line-height: .88rem;
                background-color: #de101d;
                text-align: center;
                margin: .4rem auto;
                font-size: .26rem;
                color: #fffff8;
            }
            .news_text {
                text-align: center;
                li {
                    box-sizing: border-box;
                    width: 49%;
                    height: 1.8rem;
                    background-color: #f2f2f2;
                    float: left;
                    margin-top: .4rem;
                    padding-top: .15rem;
                    color: #949494;
                    position: relative;
                    .left {
                        width: 1.05rem;
                        height: 1.5rem;
                        float: left;
                        margin-left: .25rem;
                        text-align: center;
                        border-right: 2px solid #cbcbcb;
                        span {
                            float: left;
                            font-size: .22rem;
                            line-height: .4rem;
                            width: 1.05rem;
                        }
                        .hx {
                            margin-left: .3rem;
                            width: .35rem;
                            height: .2rem;
                            line-height: .2rem;
                            border-bottom: 2px solid #cbcbcb;
                        }
                        span:nth-child(1) {
                            font-size: 32px;
                        }
                    }
                    .right {
                        width: 3.95rem;
                        float: left;
                        line-height: .4rem;
                        font-size: .3rem;
                        padding-left: .3rem;
                        text-align: left;
                        padding-top: .2rem;
                    }
                    .ckgd {
                        width: 100%;
                        height: 1.8rem;
                        background-color: #de101d;
                        margin-top: -.2rem;
                        position: absolute;
                        font-size: .2rem;
                        color: #f0fff8;
                        opacity: 0;
                        p {
                            height: .2rem;
                            display: flex;
                            padding-top: .8rem;
                            justify-content: space-between;
                            span {
                                padding: 0 .4rem;
                            }
                        }
                    }
                }
                li:nth-child(odd) {
                    margin-right: 0.24rem;
                }
                li:hover {
                    background-color: #de101d;
                    .ckgd {
                        opacity: 1;
                    }
                }
            }
        }
        .hzhb_wrap {
            width: 100%;
            max-width: 19.2rem;
            height: 6.9rem;
            position: relative;
            .img_hz {
                display: block;
                height: 6.9rem;
                width: 100%;
            }
            .hzhb {
                height: 300px;
                position: absolute;
                margin: 0 auto;
                top: 10px;
                left: 50%;
                transform: translateX(-50%) translateY(135px);
                display: flex;
                flex-wrap: wrap;
                box-sizing: border-box;
                img {
                    cursor: pointer;
                    display: block;
                    padding: 7px;
                }
            }
        }
    }
    .footer_Wrap {
        width: 100%;
        max-width: 19.2rem;
        margin: 0 auto;
        background-color: #242c39;
    }
    .footer_1 {
        height: 2.8rem;
        background-color: #242c39;
        color: #fff;
        .xx {
            display: flex;
            justify-content: space-between;

            .qx {
                margin-top: .3rem;
                height: 2.45rem;
                width: 3rem;
                .name {
                    font-size: .3rem;
                    line-height: .7rem;
                    border-bottom: 5px solid #fff;
                }
                .dizhi {
                    height: .7rem;
                    padding-top: .2rem;
                    font-size: .2rem;
                    line-height: .3rem;
                    background: url(../../static/img/dizhi.png) no-repeat left;
                    padding-left: .35rem;
                }
                .dh {
                    font-size: .16rem;
                    line-height: .7rem;
                    background: url(../../static/img/dianhua.png) no-repeat left;
                    padding-left: .35rem;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Logo.vue